import { useState } from 'react';
import { ChevronDown, ChevronRight, HelpCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const FAQPage = () => {
  const { t } = useTranslation();
  const [openItems, setOpenItems] = useState(new Set([0])); // First item open by default

  const toggleItem = (index) => {
    const newOpenItems = new Set(openItems);
    if (newOpenItems.has(index)) {
      newOpenItems.delete(index);
    } else {
      newOpenItems.add(index);
    }
    setOpenItems(newOpenItems);
  };

  const faqs = t('faq.questions', { returnObjects: true });

  return (
    <div className="max-w-4xl mx-auto space-y-8">
      {/* Header */}
      <div className="text-center">
        <div className="flex justify-center mb-4">
          <div className="p-3 bg-primary-100 rounded-full">
            <HelpCircle className="text-primary-600" size={32} />
          </div>
        </div>
        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          {t('faq.title')}
        </h1>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto">
          {t('faq.subtitle')}
        </p>
      </div>

      {/* FAQ Items */}
      <div className="space-y-4">
        {faqs.map((faq, index) => (
          <div key={index} className="card border border-gray-200 hover:border-primary-300 transition-colors">
            <button
              onClick={() => toggleItem(index)}
              className="w-full text-left flex items-center justify-between p-0"
            >
              <h3 className="text-lg font-semibold text-gray-900 pr-4">
                {faq.question}
              </h3>
              {openItems.has(index) ? (
                <ChevronDown className="text-primary-600 flex-shrink-0" size={20} />
              ) : (
                <ChevronRight className="text-gray-400 flex-shrink-0" size={20} />
              )}
            </button>
            
            {openItems.has(index) && (
              <div className="mt-4 pt-4 border-t border-gray-100">
                <p className="text-gray-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Contact Section */}
      <div className="card bg-white border-gray-200 text-center">
        <h3 className="text-xl font-semibold text-gray-900 mb-4">
          {t('faq.contactSection.title')}
        </h3>
        <p className="text-gray-800 mb-6">
          {t('faq.contactSection.description')}
        </p>
        <a 
          href="mailto:info@sranslate.nl?subject=Sranslate%20Support" 
          className="btn-primary"
        >
          {t('faq.contactSection.contactButton')}
        </a>
      </div>
    </div>
  );
};

export default FAQPage;